// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"363":"46fe9349","422":"70db14ff","730":"b77cae3f","927":"5f170b3c"}[chunkId] + ".chunk.js";
};